import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores';
import { LoginForm } from '@/features/auth/components/login-form';

export default function LoginPage() {
    const { login, isLoading, clearError, isAuthenticated } = useAuthStore();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/chat', { replace: true });
        }
    }, [isAuthenticated, navigate]);

    const validateForm = (email: string, password: string) => {
        let emailError = '';
        let passwordError = '';
        let isValid = true;

        if (!email.trim()) {
            emailError = 'Please enter your email or username';
            isValid = false;
        } else if (email.includes('@')) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                emailError = 'Please enter a valid email address';
                isValid = false;
            }
        }

        if (!password.trim()) {
            passwordError = 'Please enter a password';
            isValid = false;
        } else if (password.length < 6) {
            passwordError = 'Password must be at least 6 characters long';
            isValid = false;
        }

        return { emailError, passwordError, isValid };
    };

    const handleSubmit = async (email: string, password: string) => {
        clearError();

        const { isValid } = validateForm(email, password);

        if (!isValid) {
            return;
        }

        try {
            await login({
                email,
                password,
            });
            navigate('/chat', { replace: true });
        } catch {
            console.error('Invalid email or password');
        }
    };

    return (
        <div className='flex min-h-screen justify-center bg-[var(--stan-bg-color)] pt-6'>
            <div className='w-full max-w-md space-y-8 p-8'>
                <div className='mt-8 space-y-6'>
                    <LoginForm
                        onLogin={handleSubmit}
                        loginWithGoogle={() => {
                            // TODO: implement google login
                            console.warn('Need to implement google login');
                        }}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </div>
    );
}
